import React, { FC } from 'react'

export type Item = {
  tags: string[]
  id: number
  featured_image: string
}

export type Props = {
  item: Item
  onThumbnailChange: (val: number) => void
  active: number
}

export const Thumbnail: FC<Props> = ({ item, onThumbnailChange, active }) => {
  function changeThumbnail(e: number) {
    onThumbnailChange(e)
  }

  const name = item.tags.filter(function (tag) {
    return tag.includes('finish:')
  })[0]

  return (
    <div
      className={`Visualizer-thumbnail ${active === item.id ? 'active' : ''}`}
      onClick={() => changeThumbnail(item.id)}
    >
      <div
        style={{ backgroundImage: `url(${item.featured_image})` }}
        className="Visualizer-thumbnailImg"
      ></div>

      <div className="Visualizer-thumbnailTitle">
        {name.replace('finish:', '').replace(/algolia-filter-/ig, '')}
      </div>
    </div>
  )
}
